<template>
   <div class="topContainer">
      <div class="pageHeader">Donation Options</div>
      <div class="sectionInfo">
       <div class="sectionHeader">
       
       </div>
       <div class="sectionContent">
         <b-list-group horizontal="md">
            <b-list-group-item><div id="amznCharityBanner"/></b-list-group-item>
            <b-list-group-item>
               <div class="sectionTitle"><font-awesome-icon icon="envelope-open" /> Mail Your Check To:</div>
					<div style="marginTop: 20px" class='addressLabel'>P.O. Box 1542<br />Annapolis, MD 21404</div>
            </b-list-group-item>
            <b-list-group-item>
               <div class="sectionTitle"> Paypal Donation:</div>
					<div style='marginLeft: 20px; marginTop:20px; min-width: 250px; max-width: 400px'>
						<form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
							<input name="cmd" defaultValue="_s-xclick" type="hidden" />
							<input name="hosted_button_id" defaultValue="RWMYL4GNUP9JC" type="hidden" />
							<input src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" name="submit" alt="PayPal - The safer, easier way to pay online!" type="image" />
							<img alt='' src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width=1 height=1 />
						</form>
					</div>
            </b-list-group-item>
         </b-list-group>
       </div>
     </div>
   </div>
</template>
<script>
   let isMounted = false;
   export default {
      mounted(){
         console.log("mounted: " + isMounted);
         if(isMounted){
               document.body.removeChild(document.getElementById("amzn"));
         }

         if(document.body){
            let amazonSmileScript = document.createElement("script");
            amazonSmileScript.setAttribute("id","amzn");
            amazonSmileScript.innerHTML =  "(function() {var iFrame = document.createElement('iframe'); iFrame.style.display = 'none'; iFrame.style.border = 'none'; iFrame.width = 310; iFrame.height = 256; iFrame.setAttribute && iFrame.setAttribute('scrolling', 'no'); iFrame.setAttribute('frameborder', '0'); setTimeout(function() {var contents = (iFrame.contentWindow) ? iFrame.contentWindow : (iFrame.contentDocument.document) ? iFrame.contentDocument.document : iFrame.contentDocument; contents.document.open(); contents.document.write(decodeURIComponent(\"%3Cdiv%20id%3D%22amznCharityBannerInner%22%3E%3Ca%20href%3D%22https%3A%2F%2Fsmile.amazon.com%2Fch%2F47-4180605%22%20target%3D%22_blank%22%3E%3Cdiv%20class%3D%22text%22%20height%3D%22%22%3E%3Cdiv%20class%3D%22support-wrapper%22%3E%3Cdiv%20class%3D%22support%22%20style%3D%22font-size%3A%2025px%3B%20line-height%3A%2028px%3B%20margin-top%3A%201px%3B%20margin-bottom%3A%201px%3B%22%3ESupport%20%3Cspan%20id%3D%22charity-name%22%20style%3D%22display%3A%20inline-block%3B%22%3EMen%20Of%20Courage%20International%20Inc.%3C%2Fspan%3E%3C%2Fdiv%3E%3C%2Fdiv%3E%3Cp%20class%3D%22when-shop%22%3EWhen%20you%20shop%20at%20%3Cb%3Esmile.amazon.com%2C%3C%2Fb%3E%3C%2Fp%3E%3Cp%20class%3D%22donates%22%3EAmazon%20donates.%3C%2Fp%3E%3C%2Fdiv%3E%3C%2Fa%3E%3C%2Fdiv%3E%3Cstyle%3E%23amznCharityBannerInner%7Bbackground-image%3Aurl(https%3A%2F%2Fimages-na.ssl-images-amazon.com%2Fimages%2FG%2F01%2Fx-locale%2Fpaladin%2Fcharitycentral%2Fbanner-background-image._CB309675353_.png)%3Bwidth%3A300px%3Bheight%3A250px%3Bposition%3Arelative%7D%23amznCharityBannerInner%20a%7Bdisplay%3Ablock%3Bwidth%3A100%25%3Bheight%3A100%25%3Bposition%3Arelative%3Bcolor%3A%23000%3Btext-decoration%3Anone%7D.text%7Bposition%3Aabsolute%3Btop%3A20px%3Bleft%3A15px%3Bright%3A15px%3Bbottom%3A100px%7D.support-wrapper%7Boverflow%3Ahidden%3Bmax-height%3A86px%7D.support%7Bfont-family%3AArial%2Csans%3Bfont-weight%3A700%3Bline-height%3A28px%3Bfont-size%3A25px%3Bcolor%3A%23333%3Btext-align%3Acenter%3Bmargin%3A0%3Bpadding%3A0%3Bbackground%3A0%200%7D.when-shop%7Bfont-family%3AArial%2Csans%3Bfont-size%3A15px%3Bfont-weight%3A400%3Bline-height%3A25px%3Bcolor%3A%23333%3Btext-align%3Acenter%3Bmargin%3A0%3Bpadding%3A0%3Bbackground%3A0%200%7D.donates%7Bfont-family%3AArial%2Csans%3Bfont-size%3A15px%3Bfont-weight%3A400%3Bline-height%3A21px%3Bcolor%3A%23333%3Btext-align%3Acenter%3Bmargin%3A0%3Bpadding%3A0%3Bbackground%3A0%200%7D%3C%2Fstyle%3E\")); contents.document.close(); iFrame.style.display = 'block';}); document.getElementById('amznCharityBanner').appendChild(iFrame); })();";
            document.body.appendChild(amazonSmileScript);
            isMounted = true;
         }
      } 
   }
</script>

<style scoped>
.topContainer{
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/aavc.jpg') no-repeat center center fixed;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
     background-size: cover;
    height: 60px;
    width: 100%;
    position: relative;
    z-index: 2;
    border-bottom: 2px solid black;
    box-shadow: 1px 1px #111;
}
.addressLabel{
    margin-left: 10px;
    color: navy;
    font-weight: bold;
    font-size: 26px;
    border: 1px solid #999;
    border-radius: 4px;
    padding: 10px;
    background-color: #dfebef;
    max-width: 400px;
}
.list-group{ 
  flex-wrap: wrap;
}
.list-group-item {
  padding: 10px;
  margin:10px auto;
  text-align: center;
}
.sectionTitle{
   font-size: 1.2em;
   font-weight: bold;
}
.sectionContent{
  margin-top:0px;
}
</style>
